module.exports = [
	{
		"componentChunkName": "component---node-modules-gatsby-plugin-offline-app-shell-js",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "offline-plugin-app-shell-fallback.json",
		"path": "/offline-plugin-app-shell-fallback/"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "custom-animations.json",
		"path": "/custom-animations"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "build-a-basic-flutter-app.json",
		"path": "/build-a-basic-flutter-app"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "google-static-maps.json",
		"path": "/google-static-maps"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "architecture-auth-with-firebase-inherited-widget.json",
		"path": "/architecture-auth-with-firebase-inherited-widget"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "architecture-auth-with-redux-firebase.json",
		"path": "/architecture-auth-with-redux-firebase"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "night-sky-animation.json",
		"path": "/night-sky-animation"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "step-one-tweening.json",
		"path": "/step-one-tweening"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "step-two-animated-widget.json",
		"path": "/step-two-animated-widget"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "inherited-widget-custom-theme-class.json",
		"path": "/inherited-widget-custom-theme-class"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "dart-for-web-developers.json",
		"path": "/dart-for-web-developers"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "dmgt-test-doc-2.json",
		"path": "/dmgt-test-doc-2"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "flutter-theme-class.json",
		"path": "/flutter-theme-class"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "about-flutter.json",
		"path": "/about-flutter"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "dissecting-the-counter-app.json",
		"path": "/dissecting-the-counter-app"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "build-context-class.json",
		"path": "/build-context-class"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "stateful-widget-lifecycle.json",
		"path": "/stateful-widget-lifecycle"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "flutter-widgets.json",
		"path": "/flutter-widgets"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "setup-and-tools.json",
		"path": "/setup-and-tools"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "first-dmgt-doc.json",
		"path": "/first-dmgt-doc"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "doc-2-and-more.json",
		"path": "/doc-2-and-more"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "dart-uri-google-static-maps-api.json",
		"path": "/dart-uri-google-static-maps-api"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "make-the-static-map-interactive.json",
		"path": "/make-the-static-map-interactive"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "update-location-with-dart-streams.json",
		"path": "/update-location-with-dart-streams"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "set-up-2222-app-loading.json",
		"path": "/set-up-2222-app-loading"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "auto-login-on-startup.json",
		"path": "/auto-login-on-startup"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "log-in-flow-boiler-plate.json",
		"path": "/log-in-flow-boiler-plate"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "set-up-inherited-widget-app-state.json",
		"path": "/set-up-inherited-widget-app-state"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "state-management-the-flutter-way.json",
		"path": "/state-management-the-flutter-way"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "login-new-user.json",
		"path": "/login-new-user"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "list-view-and-builder-methods.json",
		"path": "/list-view-and-builder-methods"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "reusable-custom-card-widget.json",
		"path": "/reusable-custom-card-widget"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "gradients-background.json",
		"path": "/gradients-background"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "built-in-animation.json",
		"path": "/built-in-animation"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "data-model-http.json",
		"path": "/data-model-http"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "hero-transition.json",
		"path": "/hero-transition"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "basic-dogs-app-setup.json",
		"path": "/basic-dogs-app-setup"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "routing-2-add-new-dog-page.json",
		"path": "/routing-2-add-new-dog-page"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "routing-1-pages-on-the-fly.json",
		"path": "/routing-1-pages-on-the-fly"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "user-feedback-toasts-snackbars.json",
		"path": "/user-feedback-toasts-snackbars"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "forms-2-sliders-and-buttons.json",
		"path": "/forms-2-sliders-and-buttons"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "sample-nugget.json",
		"path": "/sample-nugget"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "forms-1-user-input.json",
		"path": "/forms-1-user-input"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "adding-firebase.json",
		"path": "/adding-firebase"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "log-in-redux-cycle.json",
		"path": "/log-in-redux-cycle"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "firebase-log-in-middleware.json",
		"path": "/firebase-log-in-middleware"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "log-in-redux-cycle-contd.json",
		"path": "/log-in-redux-cycle-contd"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "add-user-profile.json",
		"path": "/add-user-profile"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "what-is-redux.json",
		"path": "/what-is-redux"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "flutter-redux-setup.json",
		"path": "/flutter-redux-setup"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "add-a-redux-store.json",
		"path": "/add-a-redux-store"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "app-state-model.json",
		"path": "/app-state-model"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "app-reducer.json",
		"path": "/app-reducer"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "counter-redux-cycle.json",
		"path": "/counter-redux-cycle"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "logger-middleware.json",
		"path": "/logger-middleware"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "redux-wrap-up.json",
		"path": "/redux-wrap-up"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "redux-app-getting-to-start.json",
		"path": "/redux-app-getting-to-start"
	},
	{
		"componentChunkName": "component---src-templates-lesson-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "what-youll-build.json",
		"path": "/what-youll-build"
	},
	{
		"componentChunkName": "component---src-pages-about-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "about.json",
		"path": "/about/"
	},
	{
		"componentChunkName": "component---src-pages-contributors-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "contributors.json",
		"path": "/contributors/"
	},
	{
		"componentChunkName": "component---src-pages-index-jsx",
		"layout": "layout---index",
		"layoutComponentChunkName": "component---src-layouts-index-jsx",
		"jsonName": "index.json",
		"path": "/"
	}
];


//////////////////
// WEBPACK FOOTER
// ./.cache/pages.json
// module id = 498
// module chunks = 231608221292675